import { NoticeMarkup } from './types';

const plugin = {
  install(Vue) {
    if (this.installed) return;

    this.installed = true;
    this.emitter = new Vue();
    this.current = null;

    Vue.prototype.$notice = {
      success(text, markup=NoticeMarkup.PLAIN) {
        this.message(text, 'success', null, markup);
        return this;
      },

      error(errorOrText, error, markup=NoticeMarkup.PLAIN) {
        let text, currentError;

        if (errorOrText instanceof Error) {
          text = (errorOrText.response && errorOrText.response.data.message) || errorOrText.message;
          currentError = errorOrText;
        } else {
          text = errorOrText;
          currentError = error;
        }

        this.message(text, 'error', currentError, markup);
        return this;
      },

      message(text, type, error, markup=NoticeMarkup.PLAIN) {
        plugin.emitter.$emit('message', { text, type, error, markup });
        return this;
      },

      emitter: plugin.emitter,
    };
  },
};

export default plugin;
